import { useEffect, useState } from 'react';
import { getToken, setToken } from './lib/api';
import { MoneyRadar } from './pages/MoneyRadar';
import { AccountRadar } from './pages/AccountRadar';
import { AccountDetail } from './pages/AccountDetail';
import { SourceHealth } from './pages/SourceHealth';

type Route =
  | { page: 'radar' }
  | { page: 'accounts' }
  | { page: 'account'; id: string }
  | { page: 'sources' };

function parseHash(): Route {
  const hash = window.location.hash.replace(/^#\/?/, '');
  if (hash.startsWith('accounts/')) return { page: 'account', id: hash.slice('accounts/'.length) };
  if (hash === 'accounts') return { page: 'accounts' };
  if (hash === 'sources') return { page: 'sources' };
  return { page: 'radar' };
}

export function App() {
  const [route, setRoute] = useState<Route>(parseHash());
  const [hasToken, setHasToken] = useState(Boolean(getToken()));
  const [tokenInput, setTokenInput] = useState('');

  useEffect(() => {
    const onHash = () => setRoute(parseHash());
    window.addEventListener('hashchange', onHash);
    return () => window.removeEventListener('hashchange', onHash);
  }, []);

  function go(hash: string) {
    window.location.hash = hash;
  }

  if (!hasToken) {
    return (
      <div className="gate">
        <h1>ROOFING MONEY RADAR</h1>
        <p>
          Enter your access key to open the radar. During the pilot this is the operator key;
          production accounts sign in with email through Supabase Auth.
        </p>
        <input
          type="password"
          placeholder="Access key"
          value={tokenInput}
          onChange={(e) => setTokenInput(e.target.value)}
          onKeyDown={(e) => {
            if (e.key === 'Enter' && tokenInput.trim()) {
              setToken(tokenInput.trim());
              setHasToken(true);
            }
          }}
        />
        <button
          className="btn primary"
          style={{ width: '100%' }}
          disabled={!tokenInput.trim()}
          onClick={() => {
            setToken(tokenInput.trim());
            setHasToken(true);
          }}
        >
          OPEN RADAR
        </button>
      </div>
    );
  }

  return (
    <div className="shell">
      <div className="topbar">
        <div className="brand">STEEL &amp; STILETTO <span>// MONEY RADAR</span></div>
        <div className="nav">
          <button className={route.page === 'radar' ? 'active' : ''} onClick={() => go('/')}>TODAY'S MONEY RADAR</button>
          <button className={route.page === 'accounts' || route.page === 'account' ? 'active' : ''} onClick={() => go('/accounts')}>ACCOUNT RADAR</button>
          <button className={route.page === 'sources' ? 'active' : ''} onClick={() => go('/sources')}>SOURCE HEALTH</button>
        </div>
        <div className="territory-chip">ROOFING · NEWBERRY, SC · 50 MI</div>
      </div>
      <div className="main">
        {route.page === 'radar' && <MoneyRadar onOpenAccount={(id) => go(`/accounts/${id}`)} />}
        {route.page === 'accounts' && <AccountRadar onOpen={(id) => go(`/accounts/${id}`)} />}
        {route.page === 'account' && <AccountDetail id={route.id} onBack={() => go('/accounts')} />}
        {route.page === 'sources' && <SourceHealth />}
      </div>
    </div>
  );
}
